import { socketService } from "@/services/socketService";
import { useDeviceVerifierStore } from "@/stores/deviceVerifier";
import { useOrderStore } from '@/stores/order';
import { useSystemSettingsStore } from '@/stores/systemSettings';
import { useBroadcastComposable } from "@/composables/useBroadcastComposable";
import { usePos } from '@/composables/usePos';
import imageUtils from '@/utils/imageUtils';

export function usePosEventListener() {
    const { removeListener } = socketService;

    const { resetVerifier } = useDeviceVerifierStore();
    const { resetSystemSettings, setDefaultLogo, setLogo, setSystemName, setDefaultSystemName } = useSystemSettingsStore();
    const { resetOrder } = useOrderStore();
    const { verifyPosClientIdOnEvent } = useBroadcastComposable();
    const { getPosByXClientId } = usePos();

    const posReloadEvent = "kiosk_reload"
    const posSystemSettingsEvent = "systemSettings"

    const handlePosReload = async (receivedData) => {
        if (typeof receivedData?.kiosk === 'object' && 
            typeof receivedData.kiosk?.kiosk_uuid === 'string' && 
            verifyPosClientIdOnEvent(receivedData.kiosk.kiosk_uuid)
        ) {
            const data = receivedData.kiosk;
            if ('is_update' in data && data.is_update === true) {
                const pos = await getPosByXClientId();
                if (pos) {
                    updateSystemLogo(pos?.logo_url);
                }
            }
            if ('is_delete' in data && data.is_delete === true) {
                /**
                 * First we reset the device verifier store.
                 * This will clear the current state of the device verifier.
                 */
                resetVerifier();
                /* Reset system settings in localStorage. */
                resetSystemSettings();
                /* Reset orders in localStorage. */
                resetOrder();
                /* Remove the listener */
                removeListener(posReloadEvent);
                removeListener(posSystemSettingsEvent);
                /* Redirect to home page to show the verification modal. */
                window.location.href = "/";
            }
        } else {
            console.warn("Received POS reload event with invalid data or POS UUID does not match.");
        }
    }

    const handleSystemSettingsEvent = async (receivedData) => {
        if (typeof receivedData?.settings === 'object') {
            if ('logo' in receivedData.settings) {
                const logo = receivedData.settings.logo;
                const systemName = receivedData.settings.name;
                updateSystemLogo(logo);
                updateSystemName(systemName);
            }
        }
    }

    const updateSystemLogo = (imageUrl) => {
        if (typeof imageUrl === 'string' && imageUrl.trim().length > 0) {
            setLogo(imageUtils.getImageUrl(imageUrl));
        } else {
            setDefaultLogo();
        }
    }

    const updateSystemName = (name) => {
        if (typeof name === 'string' && name.trim().length > 0) {
            setSystemName(name);
        } else {
            setDefaultSystemName();
        }
    }

    const getPosReloadEventName = () => {
        return posReloadEvent;
    }

    const getPosSystemSettingsEventName = () => {
        return posSystemSettingsEvent
    }

    return {
        getPosReloadEventName,
        getPosSystemSettingsEventName,
        handlePosReload,
        handleSystemSettingsEvent,
        updateSystemLogo,
        updateSystemName
    }
}